import React from 'react';

const MyLibraryButton = ({ className, onClick, text, disabled, customStyles, children }) => {
  return (
    <button onClick={onClick} className={className} disabled={disabled} style={{ ...customStyles }}>
      {children}
      {text}
    </button>
  );
};

export default MyLibraryButton;
